export default (value, place = 'pt-br', currency = 'BRL') =>
  value.toLocaleString(place, { style: 'currency', currency: currency })
